export default __webpack_public_path__ + "static/media/vish.0c43c8c0.png";